import { Component, Input, OnInit } from '@angular/core';
import { KanbamFiltro } from 'src/app/kanbam/KanbamFiltro';
import { KanbanService } from 'src/app/services/kanban.service';

@Component({
  selector: 'app-botao-filtro-pedido',
  templateUrl: './botao-filtro-pedido.component.html',
  styleUrls: ['./botao-filtro-pedido.component.css']
})
export class BotaoFiltroPedidoComponent implements OnInit {

  @Input() configuracao: KanbamFiltro;
  constructor(private kanbanService: KanbanService) { }

  ngOnInit(): void {
  }

  toogleFiltro() {
    this.configuracao.ativo = !this.configuracao.ativo;
    this.kanbanService.onChangeFiltroPedidos$.next(this.configuracao);
  }

}
